import React, { Component} from 'react';
import { connect } from 'react-redux';
import actions from 'actions';
import NovoNordiskUsers from 'components/Admin/User/NovoNordiskUsers'

const {
  loadNovonordiskUsersSaga,
  addNovonordiskUsers
} = actions;

class NovoNordiskUsersContainer extends Component {

  componentDidMount() {
    this.props.loadNovonordiskUsers();
  }

  componentWillMount() {
    this.props.cleanAdminUsersWebinars();
  }

  render() {
    return (
      <main className="site--width clearfix container_statistics">
        <div className="container_admin_webinar_users">
          <NovoNordiskUsers values={this.props.users || []}/>
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.users.novonordiskUsers
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadNovonordiskUsers: () => dispatch(loadNovonordiskUsersSaga()),
    cleanAdminUsersWebinars: () => dispatch(addNovonordiskUsers([]))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NovoNordiskUsersContainer)



// WEBPACK FOOTER //
// ./src/containers/Admin/User/NovoNordiskUsers/NovoNordiskUsers.jsx